var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomBlueSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 375 374.999991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#54beff",
    d: "M 160.269531 208.886719 L 170.964844 208.886719 C 173.90625 208.886719 176.316406 211.296875 176.316406 214.238281 L 176.316406 224.933594 C 176.316406 227.875 173.90625 230.285156 170.964844 230.285156 L 160.269531 230.285156 C 157.324219 230.285156 154.917969 227.875 154.917969 224.933594 L 154.917969 214.238281 C 154.917969 211.296875 157.324219 208.886719 160.269531 208.886719 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomBlueSquare);
export default __webpack_public_path__ + "static/media/BottomBlueSquare.7fd51928642a7a98a6971ce2f7f9b221.svg";
export { ForwardRef as ReactComponent };